exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._17D1C{position:relative;width:100%;height:100%;min-height:100px;min-width:100px;background-color:#f2f2f2;text-align:center}body.reader-night-mode ._17D1C{background-color:#3d3d3d}._17D1C span{display:block;font-size:64px;color:#e6e6e6;text-shadow:0 1px 0 #fff;position:absolute;top:50%;left:50%;margin-top:-48px;margin-left:-72px}body.reader-night-mode ._17D1C span{color:#4d4d4d;text-shadow:0 1px 0 #595959}", ""]);

// exports
exports.locals = {
	"no-content": "_17D1C"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/components/EmptyContent/EmptyContent.scss
// module id = yqWn
// module chunks = 6